import { GoalId, isGoalType } from './Goals2/types';
import { routes } from '../../routes';

export const GOAL_ID_QUERY_PARAM = 'goalId';
export const CREATE_GOAL_ID = 'createGoal';

export type GoalIdOrCreateGoal = GoalId | typeof CREATE_GOAL_ID;

export const getGoalRoute = (isManagerView: boolean) => {
  return !isManagerView
    ? routes.performanceReviewGoals.route
    : routes.goals.route;
};

export function goalIdToStr(goalId: GoalIdOrCreateGoal): string {
  if (goalId === CREATE_GOAL_ID) {
    return CREATE_GOAL_ID;
  }
  return `${goalId.id}_${goalId.type}`;
}

export function parseGoalId(goalIdStr: string): GoalIdOrCreateGoal {
  if (goalIdStr === CREATE_GOAL_ID) {
    return CREATE_GOAL_ID;
  }
  const parts = goalIdStr.split('_');
  if (parts.length !== 2) {
    throw new Error('Invalid goal ID');
  }
  const goalTypeStr = parts[1];
  if (!isGoalType(goalTypeStr)) {
    throw new Error('Invalid goal type');
  }
  return { id: parts[0], type: goalTypeStr };
}
